import { useInView } from 'react-intersection-observer'
import { grid, gridColumnsRoot } from '../../../../utils/grid'
import React, { FunctionComponent } from 'react'
import styled, { css, SimpleInterpolation } from 'styled-components'
import Text, { TextProps } from '../../../molecules/text/Text'
import { mediaQueries } from '../../../../utils/mediaQueries'
import { SectionProps } from '../Sections'
import { spacing } from '../../../../utils/spacing'

type Alignment = 'left' | 'right'

export interface TextSectionProps extends TextProps, SectionProps {
  alignment?: Alignment
}

const TextSection: FunctionComponent<TextSectionProps> = ({
  alignment = 'left',
  className,
  lead,
  link,
  text,
  title,
}) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  })

  return (
    <StyledTextSection className={className} ref={ref}>
      <TextWrapper alignment={alignment}>
        <Text
          animateIn={inView}
          lead={lead}
          link={link}
          text={text}
          title={title}
        />
      </TextWrapper>
    </StyledTextSection>
  )
}

const StyledTextSection = styled.div`
  ${grid()}
  ${spacing()}
`

interface TextWrapperProps {
  alignment: Alignment
}

const TextWrapper = styled.div<TextWrapperProps>`
  grid-column: 1 / span ${gridColumnsRoot};

  ${mediaQueries.tablet} {
    grid-column: 1 / span 6;
  }

  ${mediaQueries.desktop} {
    grid-column: 1 / span 8;
  }

  ${({ alignment }): SimpleInterpolation =>
    alignment === 'right' &&
    css`
      ${mediaQueries.tablet} {
        grid-column-start: 3;
      }

      ${mediaQueries.desktop} {
        grid-column-start: 7;
      }
    `}
`

export default TextSection
